import { motion } from 'framer-motion';
import { useContent } from '../contexts/ContentContext';
import { FaWhatsapp } from 'react-icons/fa';
import heroImage from '../assets/hero-image.jpg';
import logo from '../assets/logo.png';

const Hero = () => {
  const { content } = useContent();
  const heroContent = content.hero || {};

  return (
    <section id="inicio" className="min-h-screen bg-[#F8F3F0] relative overflow-hidden">
      {/* Fixed Navigation */}
      <motion.nav 
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.5 }}
        className="fixed top-0 left-0 right-0 bg-[#F8F3F0] z-50 border-b border-[#D4B4A8]/10"
      >
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center py-4">
            {/* Logo */}
            <motion.a
              href="#inicio"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="hover:opacity-80 transition-opacity duration-300"
            >
              <img 
                src={logo} 
                alt="Késia Almeida Logo" 
                className="h-12 w-auto"
              />
            </motion.a>

            {/* Navigation Links */}
            <div className="flex items-center space-x-8">
              {['Sobre', 'Serviços', 'Contato'].map((item, index) => {
                // Converter o texto do item para o formato de ID apropriado
                const itemId = item.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
                return (
                  <motion.a
                    key={item}
                    href={`#${itemId}`}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                    className="relative group"
                  >
                    <span className="text-[#4A3B36] font-medium transition-colors duration-300 group-hover:text-[#D4B4A8]">
                      {item}
                    </span>
                    <motion.div
                      className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-[#D4B4A8] to-[#4A3B36] origin-left"
                      initial={{ scaleX: 0 }}
                      whileHover={{ scaleX: 1 }}
                      transition={{ duration: 0.3 }}
                    />
                  </motion.a>
                );
              })}

              {/* Agendar Button */}
              <motion.a
                href="https://api.whatsapp.com/send/?phone=5562982615656"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary flex items-center gap-2"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaWhatsapp className="text-xl" />
                Agendar
              </motion.a>
            </div>
          </div>
        </div>
      </motion.nav>

      {/* Main Content Container */}
      <div className="relative pt-20">
        {/* Decorative Elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-[#D4B4A8]/30 to-transparent rounded-full filter blur-3xl transform translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-[#4A3B36]/20 to-transparent rounded-full filter blur-3xl transform -translate-x-1/2 translate-y-1/2"></div>

        {/* Hero Content */}
        <div className="container mx-auto px-4 pt-12">
          <div className="grid md:grid-cols-2 gap-12 items-center min-h-[calc(100vh-120px)]">
            {/* Text Content */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="space-y-6"
            >
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <h1 className="text-4xl md:text-5xl font-bold text-[#4A3B36] leading-tight">
                  {heroContent.title || 'Psicóloga Clínica'}
                </h1>
                <p className="text-xl text-[#6B5C57] mt-4 max-w-xl">
                  {heroContent.description || 'Especialista em Terapia Cognitivo-Comportamental, ajudando pessoas a encontrarem seu equilíbrio emocional.'}
                </p>
                <blockquote className="italic text-lg text-[#4A3B36]/80 border-l-4 border-[#D4B4A8] pl-4 my-8">
                  "A terapia é um espaço de autoconhecimento, crescimento e transformação."
                </blockquote>
              </motion.div>
            </motion.div>

            {/* Image */}
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6 }}
              className="relative"
            >
              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="absolute -inset-4 bg-gradient-to-br from-[#D4B4A8] to-[#4A3B36] rounded-2xl transform -rotate-6"
              />
              <img
                src={heroContent.image || heroImage}
                alt="Kesia Almeida"
                className="relative w-full h-[600px] object-cover rounded-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500"
              />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
